import { FormattedMessage } from 'react-intl';
import { Outlet, generatePath } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  ANY_SPORT_SCOUTING_CENTER_STATS,
  ANY_SPORT_SCOUTING_CENTER_WATCHLISTS,
  NBA_SCOUTING_CENTER_MATCHES,
  NBA_SCOUTING_CENTER_MATCHES_DAY_GAMEID,
  NBA_SCOUTING_CENTER_SCORES,
  NBA_SCOUTING_CENTER_SCORES_GAMEID,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import {
  glossary,
  navLabels,
  scoutingCenter,
} from '@sorare/core/src/lib/glossary';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

enum ScoutingCenterTabs {
  SCORES = 'SCORES',
  STATS = 'STATS',
  WATCHLISTS = 'WATCHLISTS',
  MATCHES = 'MATCHES',
}

const tabs = (useNewNbaGameCenter: boolean) =>
  [
    {
      tab: ScoutingCenterTabs.STATS,
      label: navLabels.stats,
      to: generateSportPath(ANY_SPORT_SCOUTING_CENTER_STATS, {
        sport: Sport.NBA,
      }),
      matches: [ANY_SPORT_SCOUTING_CENTER_STATS],
    },
    useNewNbaGameCenter && {
      tab: ScoutingCenterTabs.MATCHES,
      label: glossary.games,
      to: generatePath(NBA_SCOUTING_CENTER_MATCHES),
      matches: [
        NBA_SCOUTING_CENTER_MATCHES,
        NBA_SCOUTING_CENTER_MATCHES_DAY_GAMEID,
      ],
    },
    !useNewNbaGameCenter && {
      tab: ScoutingCenterTabs.SCORES,
      label: glossary.games,
      to: generatePath(NBA_SCOUTING_CENTER_SCORES),
      matches: [NBA_SCOUTING_CENTER_SCORES, NBA_SCOUTING_CENTER_SCORES_GAMEID],
    },
    {
      tab: ScoutingCenterTabs.WATCHLISTS,
      label: scoutingCenter.watchlists,
      to: generateSportPath(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS, {
        sport: Sport.NBA,
      }),
      matches: [ANY_SPORT_SCOUTING_CENTER_WATCHLISTS],
    },
  ].filter(Boolean);

const ScoutingCenterLayout = () => {
  const {
    flags: { useNewNbaGameCenter = false },
  } = useFeatureFlags();

  return (
    <ContentWithStickyHeader
      header={
        <TabBar variant="flat" fullWidth ignoreQueryParams>
          {tabs(useNewNbaGameCenter).map(({ to, tab, label, matches }) => (
            <Tab key={tab} to={to} matches={matches}>
              <FormattedMessage {...label} />
            </Tab>
          ))}
        </TabBar>
      }
    >
      <Outlet />
    </ContentWithStickyHeader>
  );
};

export default ScoutingCenterLayout;
